import { NgModule } from '@angular/core';

import { FeatherIconDirective } from '@core/directives/core-feather-icons/core-feather-icons';
import { RippleEffectDirective } from '@core/directives/core-ripple-effect/core-ripple-effect.directive';
import { DefaultImageDirective } from './default-image-src/default-image-src.directive';
import { NGSelectDirective } from './ngselect-more-icon/ngselect-more-icon.directive';

@NgModule({
  declarations: [RippleEffectDirective, FeatherIconDirective, DefaultImageDirective, NGSelectDirective],
  exports: [RippleEffectDirective, FeatherIconDirective, DefaultImageDirective, NGSelectDirective],
})
export class CoreDirectivesModule {}
